import { c as _c } from "react/compiler-runtime";
import { Block } from "common/types/graphql";
import { BlocksRenderer } from "../BlocksRenderer";
export interface ListProps {
  ordered: boolean;
  blocks?: Block[];
  items?: string[];
}
export const List = t0 => {
  "use memo";

  const $ = _c(7);
  const {
    ordered,
    blocks,
    items
  } = t0;
  let listItems;
  if (items) {
    let t1;
    if ($[0] !== items) {
      t1 = items.map(_temp);
      $[0] = items;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    listItems = t1;
  } else {
    if (blocks) {
      let t1;
      if ($[2] !== blocks) {
        t1 = blocks.map(_temp2);
        $[2] = blocks;
        $[3] = t1;
      } else {
        t1 = $[3];
      }
      listItems = t1;
    }
  }
  let t1;
  if ($[4] !== listItems || $[5] !== ordered) {
    t1 = ordered ? <ol className="mb-4 max-w-(--breakpoint-lg) list-outside list-decimal space-y-3 pl-5 font-serif lg:text-xl">{listItems}</ol> : <ul className="mb-4 max-w-(--breakpoint-lg) list-outside list-disc space-y-3 pl-5 font-serif lg:text-xl">{listItems}</ul>;
    $[4] = listItems;
    $[5] = ordered;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  return t1;
};
function _temp(item, index) {
  return <li key={index}>{item}</li>;
}
function _temp2(block, index_0) {
  return <li key={index_0}><BlocksRenderer blocks={block.props.blocks} /></li>;
}